export default __webpack_public_path__ + "static/media/engine2.87c3c40a.mp3";